import { useState } from 'react';
import { useAuth } from '../AuthModule';
import AdminToolsBackToolbar from './AdminToolsBackToolbar';
import { DAILY_QUESTION_MAX_CHARS } from '../../config/dailyQuestion';

const API = process.env.REACT_APP_API_URL || '';

function parseOptionsLines(text) {
  const lines = text
    .split(/\r?\n/)
    .map((l) => l.trim())
    .filter(Boolean);
  return lines.length ? lines : null;
}

export default function AdminDailyQuestionPage() {
  const { user } = useAuth();
  const [question, setQuestion] = useState('');
  const [optionsText, setOptionsText] = useState('');
  const [status, setStatus] = useState(null);
  const [error, setError] = useState(null);
  const [saving, setSaving] = useState(false);

  if (!user) {
    return (
      <div className="App-block Admin-tools-page">
        <AdminToolsBackToolbar />
        <p>Kirjaudu sisään.</p>
      </div>
    );
  }

  if (user.role !== 'admin') {
    return (
      <div className="App-block Admin-tools-page">
        <AdminToolsBackToolbar />
        <p>Tämä sivu on vain ylläpitäjille.</p>
      </div>
    );
  }

  const onSubmit = (e) => {
    e.preventDefault();
    setError(null);
    setStatus(null);
    const q = question.trim();
    if (!q) {
      setError('Kirjoita kysymys.');
      return;
    }
    const opts = parseOptionsLines(optionsText);
    const userIdStr = String(user.id).replace(/n$/, '');
    setSaving(true);
    fetch(`${API}/api/daily-questions`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        userId: userIdStr,
        question: q,
        options: opts,
      }),
    })
      .then(async (r) => {
        const data = await r.json().catch(() => ({}));
        if (!r.ok) throw new Error(data.error || 'Virhe');
        return data;
      })
      .then((data) => {
        setStatus(
          `Kysymys tallennettu (id ${data.id}). Näkyy mainospalkissa, kun \`queue.js\` on lisännyt sen jonoon.`,
        );
        setQuestion('');
        setOptionsText('');
      })
      .catch((err) => setError(err.message || 'Virhe'))
      .finally(() => setSaving(false));
  };

  return (
    <div className="App-block Admin-tools-page">
      <AdminToolsBackToolbar />

      <h1 className="Admin-tools-title">Luo päivän kysymys</h1>

      <section className="Admin-daily-question" aria-label="Päivän kysymys — lomake">
        <p className="Admin-daily-question-hint">
          Lisää uusi rivi tietokantaan. Kysymys enintään {DAILY_QUESTION_MAX_CHARS} merkkiä. Jätä vaihtoehdot tyhjiksi,
          jos vastaus on vapaa teksti. Monivalintaan kirjoita vähintään kaksi riviä (yksi vaihtoehto per rivi); yksi
          vaihtoehto yksinään ei ole sallittu.
        </p>

        <form className="Admin-daily-question-form" onSubmit={onSubmit}>
          <label className="Admin-daily-question-label">
            Kysymys
            <textarea
              className="Admin-daily-question-textarea"
              value={question}
              onChange={(e) => setQuestion(e.target.value)}
              rows={5}
              maxLength={DAILY_QUESTION_MAX_CHARS}
              required
              disabled={saving}
              placeholder="Esimerkki: Mikä on lempivärisi?"
            />
          </label>

          <label className="Admin-daily-question-label">
            Vaihtoehdot (valinnainen, yksi per rivi)
            <textarea
              className="Admin-daily-question-textarea Admin-daily-question-textarea--options"
              value={optionsText}
              onChange={(e) => setOptionsText(e.target.value)}
              rows={6}
              disabled={saving}
              placeholder={'Punainen\nSinainen\nVihreä'}
            />
          </label>

          {error ? (
            <p className="Admin-daily-question-error" role="alert">
              {error}
            </p>
          ) : null}
          {status ? (
            <p className="Admin-daily-question-status" role="status">
              {status}
            </p>
          ) : null}

          <div className="Admin-daily-question-actions">
            <button type="submit" className="Button" disabled={saving}>
              {saving ? 'Tallennetaan…' : 'Tallenna kysymys'}
            </button>
          </div>
        </form>
      </section>
    </div>
  );
}
